import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { GenderKeyEnum } from 'src/shared/models/enums/genderKey.enum';
import { StatisticsChartPie } from './statisticsChartPie';
import { StatisticsContentHeader } from './statisticsContentHeader';
import { MemberSexResponse } from '../models/ageAndGenderDistribution';

type StatisticsAgeDistributionProps = {
  dataList: MemberSexResponse[];
};

export const StatisticsAgeDistribution = (props: StatisticsAgeDistributionProps) => {
  const { dataList } = props;
  const { t } = useTranslation();

  const maleCategory = useMemo(() => (dataList ?? []).find((item) => item.key === GenderKeyEnum.Male), [dataList]);
  const womanCategory = useMemo(() => (dataList ?? []).find((item) => item.key === GenderKeyEnum.Woman), [dataList]);
  const unknownCategory = useMemo(() => (dataList ?? []).find((item) => item.key === GenderKeyEnum.Unknown), [dataList]);

  const totals = {
    male: maleCategory?.count ?? 0,
    woman: womanCategory?.count ?? 0,
    unknown: unknownCategory?.count ?? 0,
  };

  return (
    <Grid container p={4} pb={2} mt={2}>
      <Grid item xs={12} lg={4}>
        <StatisticsContentHeader
          title={t('statistics:ageAndGenderDistribution.men')}
          subtitle={totals.male.toString()}
          endEndornment={t('statistics:ageAndGenderDistribution.pcs')}
        />
        <StatisticsChartPie ageSpans={maleCategory?.ageSpans ?? []} />
      </Grid>

      <Grid item xs={12} lg={4}>
        <StatisticsContentHeader
          title={t('statistics:ageAndGenderDistribution.womens')}
          subtitle={totals.woman.toString()}
          endEndornment={t('statistics:ageAndGenderDistribution.pcs')}
        />
        <StatisticsChartPie ageSpans={womanCategory?.ageSpans ?? []} />
      </Grid>
      <Grid item xs={12} lg={4}>
        <StatisticsContentHeader
          title={t('statistics:ageAndGenderDistribution.unknownGender')}
          subtitle={totals.unknown.toString()}
          endEndornment={t('statistics:ageAndGenderDistribution.pcs')}
        />
        <StatisticsChartPie ageSpans={unknownCategory?.ageSpans ?? []} />
      </Grid>
    </Grid>
  );
};
